/**
 * Парсинг объёма двигателя в cc из строки инвентаря (поле engineDisplacement).
 * Примеры: "1.197 cm³" → 1197, "1300" → 1300, "2.0" → 2000, "1500cc Turbo" → 1500.
 * @param {string|number|null|undefined} displacement
 * @returns {number|null} объём в cc, либо null если значение пустое / не распарсилось
 */
export const parseEngineCC = (displacement) => {
  if (!displacement) return null;
  const match = String(displacement).match(/([\d.]+)/);
  if (!match) return null;
  const value = parseFloat(match[1]);
  // Если значение меньше 20, вероятно это литры (2.0L) — умножаем на 1000
  const cc = value < 20 ? Math.round(value * 1000) : Math.round(value);
  return cc > 0 ? cc : null;
};
